import Repository from '../Repository';
//import dateUtils from "@/utils/dateUtils";

export default {

	addUpdateAssessmentPrice(periodId, qualificationId, assessmentTypeId, actionTypeId, price, subjectId, assessmentCodeId) {
		var response = Repository.put('Payment/AddUpdateAssessmentPrice', {
			periodId: periodId,
			qualificationId: qualificationId,
			assessmentTypeId: assessmentTypeId,
			actionTypeId: actionTypeId,
			price: parseFloat(price),
			subjectId: subjectId,
			assessmentCodeId: assessmentCodeId
		});
		return response;
	},

	getActionTypes() {
		var response = Repository.get('Payment/GetActionTypes', {});
		return response;
	},

	getAssessmentPrices(pageSize, pageNumber, searchString, periodIds, qualificationIds, assessmentTypeIds, actionTypeIds, subjectIds, assessmentCodeIds) {
		var response = Repository.get('Payment/GetAssessmentPrices', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,				
				searchString: searchString,
				periodIdCSV: periodIds.join(','),
				qualificationIdCSV: qualificationIds.join(','),
				assessmentTypeIdCSV: assessmentTypeIds.join(','),
				actionTypeIdCSV: actionTypeIds.join(','),
				subjectIdCSV: subjectIds.join(','),
				assessmentCodeIdCSV: assessmentCodeIds.join(',')
			}
		});
		return response;
	},

	getAssessmentPricesCsv(searchString, periodIds, qualificationIds, assessmentTypeIds, actionTypeIds, subjectIds, assessmentCodeIds) {
		var response = Repository.get('Payment/GetAssessmentPrices', {
			params: {			
				searchString: searchString,
				periodIdCSV: periodIds.join(','),
				qualificationIdCSV: qualificationIds.join(','),
				assessmentTypeIdCSV: assessmentTypeIds.join(','),
				actionTypeIdCSV: actionTypeIds.join(','),
				subjectIdCSV: subjectIds.join(','),
				assessmentCodeIdCSV: assessmentCodeIds.join(','),				
				csv: true
			}
		});
		return response;
	},

	getPaymentGroups(pageSize, pageNumber, searchString, markerSearchString, vendorCodeSearchString, batchCodeSearchString) {
		var response = Repository.get('Payment/GetPaymentGroups', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,				
				searchString: searchString,
				markerSearchString: markerSearchString,
				vendorCodeSearchString: vendorCodeSearchString,
				batchCodeSearchString: batchCodeSearchString,
				orderDirection: 'desc'
			}
		});
		return response;
	},

	getPaymentGroupsCsv(searchString, markerSearchString, vendorCodeSearchString, batchCodeSearchString) {
		var response = Repository.get('Payment/GetPaymentGroups', {
			params: {				
				searchString: searchString,
				markerSearchString: markerSearchString,
				vendorCodeSearchString: vendorCodeSearchString,
				batchCodeSearchString: batchCodeSearchString,				
				orderDirection: 'desc',
				csv: true
			}
		});
		return response;
	},

	processGroupPayment(paperIds) {
		var response = Repository.post('Payment/ProcessGroupPayment', {
			paperIdCSV: (paperIds == null) ? null : paperIds.join(',')
		});
		return response;
	},

	retryPayment(paymentGroupId) {
		var response = Repository.put('Payment/RetryPayment', {
			paymentGroupId: paymentGroupId
		});
		return response;
	},

	getPaymentAuditLogs(pageSize, pageNumber, searchString) {
		let payLoad = {params: {}};
		payLoad.params = { 
			pageSize: pageSize,
			pageNumber: pageNumber,
			SearchString: searchString,
			isActive: true,
			orderDirection: 'desc',
			SortBy: 'createTime', 
		}
		let response = Repository.get('Payment/getPaymentAuditLogs', payLoad);
		return response;
	},

}
